import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Box,
  Typography,
  Avatar,
  Divider,
} from "@material-ui/core";

const currencyFmt = (v, code = "USD") =>
  new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: code,
    maximumFractionDigits: 0,
  }).format(v || 0);

const formatDate = (value) => {
  if (!value) return "Unknown date";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(+date)) return "Unknown date";
  return date.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export default function RecentPaymentsCard({
  title = "Recent Payments",
  payments = [],
  currency = "USD",
  maxItems = 10,
}) {
  const items = payments.slice(0, maxItems);
  return (
    <Card variant="outlined" style={{ height: "100%" }}>
      <CardHeader
        title={title}
        subheader={
          items.length
            ? `${items.length} payment${items.length === 1 ? "" : "s"}`
            : "No payments logged"
        }
      />
      <CardContent style={{ maxHeight: 360, overflowY: "auto" }}>
        {items.length === 0 ? (
          <Typography variant="body2" color="textSecondary">
            There are no recent payments to display.
          </Typography>
        ) : (
          items.map((record, idx) => (
            <React.Fragment key={record._id || idx}>
              <Box display="flex" alignItems="center" py={1}>
                <Avatar style={{ marginRight: 12 }}>
                  {(record?.paidBy || "?").charAt(0).toUpperCase()}
                </Avatar>
                <Box flex={1} minWidth={0}>
                  <Typography variant="body2" style={{ fontWeight: 600 }} noWrap>
                    {record?.paidBy || "Unknown payer"}
                  </Typography>
                  <Typography variant="caption" color="textSecondary" noWrap>
                    {formatDate(record?.datePaid)}
                    {record?.paymentMethod ? ` • ${record.paymentMethod}` : ""}
                  </Typography>
                  {record?.note && (
                    <Typography
                      variant="caption"
                      color="textSecondary"
                      style={{ display: "block" }}
                      noWrap
                    >
                      {record.note}
                    </Typography>
                  )}
                </Box>
                <Typography
                  variant="body2"
                  style={{
                    fontWeight: 600,
                    color: "#0f9d58",
                    whiteSpace: "nowrap",
                    marginLeft: 12,
                  }}
                >
                  {currencyFmt(record?.amountPaid, currency)}
                </Typography>
              </Box>
              {idx !== items.length - 1 && <Divider />}
            </React.Fragment>
          ))
        )}
      </CardContent>
    </Card>
  );
}
